<template>
    <div class="navbar">
        
      <nav class="deep-purple darken-1">
          
          <div class="container">
              <router-link v-if="user" :to="{name:'Index'}" class = "brand-logo left"> Whereabouts</router-link>
            <ul class = "right">
               
                <li> <router-link v-if="!user" :to="{name:'Signup'}" class="signup" >Signup</router-link></li>
                <li> <router-link v-if="!user" :to="{name:'Login'}" class="login" >Login</router-link></li>
                <li v-if="user" ><a @click="logout" class="logout">Logout</a></li>
               
            </ul>
          
        </div>
      </nav>
        
    </div>
</template>
<script>
import firebase from "firebase"
export default {
    data(){
        return{
            user:null,
           

        }
    },
    methods :{
        logout(){
            firebase.auth().signOut().then(() => {
            this.$router.push({name:"Index"})
         })
        }
    },
      created(){
     // let user = firebase.auth().currentUser 
       firebase.auth().onAuthStateChanged((user) => {
           if(user){
               this.user = user
           }else{
               this.user = null
           }
       })
    }
}
</script>
<style>

</style>






// WEBPACK FOOTER //
// src/components/Navbar.vue